Chart.register({
    id: 'whiteBackground',
    beforeDraw: (chart) => {
        const ctx = chart.canvas.getContext('2d');
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, chart.width, chart.height);
    }
});

require('./measurements-count.js');
require('./ecg-single');
require('./ecg-multiple');
require('./ossimeter');
require('./thermometer');
require('./thermometerLineChart');
require('./sphygmomanometer');
require('./sphygmomanometer_rm');
require('./glucometer');
require('./liquid');
require('./urin');
require('./dreinage');
require('./scale');

require('./BpmChart');
require('./DistanceChart');
require('./SpeedChart');
require('./StateMovementChart');
require('./CaloriesChart');